import {Component, EventEmitter, Input, OnChanges, OnInit, SimpleChanges} from '@angular/core';
import {BsModalRef} from "ngx-bootstrap";
import {CoreDataService} from "../../services/wrapper/core-data.service";
import {NotificationService} from "../../services/common/notification.service";
import {AttachmentService} from "../../services/attachment.service";

@Component({
  selector: 'app-attachment-upload',
  templateUrl: './attachment-upload.component.html',
  styleUrls: ['./attachment-upload.component.scss']
})
export class AttachmentUploadComponent implements OnInit, OnChanges {
  @Input() acceptString: string;
  @Input() isMultiple = false;
  @Input() showBodyHeader = true;
  @Input() saveCallback:Function;
  @Input() closeModalCallback?:Function;
  @Input() isFrontendElement:boolean;


  public event: EventEmitter<any> = new EventEmitter();

  attachment = {
    localization: {},
    frontendElement: false
  };
  public files: any[] = [];
  public languages: any[];

  constructor(public bsModalRef: BsModalRef, private coreDataService: CoreDataService, private notificationService: NotificationService, private attachmentService: AttachmentService) {
  }

  ngOnInit() {
    this.languages = this.coreDataService.getLanguages();
    this.clear();
  }

  ngOnChanges(changes: SimpleChanges): void {
    // console.log(changes);
  }

  save() {
    let error = false;
    this.languages.forEach(lang => {
      if (this.attachment.localization[lang.code].title.length < 1) {
        error = true;
      }
    });
    if (this.files.length < 1) {
      error = true;
    }
    if (error == true) {
      this.notificationService.showWarning('general.notValidForm');
      return false;
    }
    const originalLocalization = Object.assign({}, this.attachment.localization);
    // alert(originalLocalization);
    this.files.forEach((file) => {
      let toSave = null;
      if (this.files.length > 1) {
        toSave = {localization: {}, frontendElement:this.isFrontendElement};
        Object.keys(this.attachment.localization).forEach(key => {
          toSave.localization[key] = {};
          toSave.localization[key]['title'] = this.attachment.localization[key].title + " " + file.name;
        });
      } else {
        this.attachment.frontendElement = this.isFrontendElement;
        toSave = this.attachment;
      }
      this.attachmentService.saveFileAndAttachment(file, toSave).subscribe(resp => {
        this.saveCallback(resp);
      });
    });
    this.clear();
  }

  private clear() {
    this.files = [];
    this.languages.forEach(lang => {
      this.attachment.localization[lang.code] = {};
      this.attachment.localization[lang.code]['title'] = "";
    });
    if(this.closeModalCallback != undefined){
      this.closeModalCallback();
    }
  }

  removeFile(index: number) {
    this.files.splice(index, 1);
  }

}
